import { Injectable } from '@angular/core';
import { App } from '@df/core/app';
import { TimeoutService } from '@df/ng/timeout.service';
import { CustomerModel } from '@df/session/api/customer.model';
import { AbstractDfModalInitiatorService } from '@df/ui/modal/abstract-df-modal-initiator.service';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NNewsletterModal } from './cms-newsletter-modal.component';

@Injectable({
    providedIn: 'root'
})
export class NewsletterModalModalInitiatorService extends AbstractDfModalInitiatorService {
    constructor(
        dfModalService: DfModalService,
        app: App,
        private customerModel: CustomerModel,
        private iCmsBlockResource: ICmsBlockResource,
        private timeoutService: TimeoutService
    ) {
        super(dfModalService, app);
    }

    async listen(cb: () => void): Promise<void> {
        await this.customerModel.load();
        if (!this.customerModel.data.subscribed) {
            const block = (await this.iCmsBlockResource.retrieve(
                { bareUrl: NNewsletterModal.blockId },
                undefined
            )) as NNewsletterModal.Block;
            const content = block?.data?.content;
            if (content && !content.styles?.hidden) {
                const delay = content.delay;
                if (delay) {
                    this.timeoutService.setTimeout(() => cb(), delay * 1000);
                } else {
                    cb();
                }
            }
        }
    }
}
